import Types from "./actionType";

export const rehydrateMovementStateSuccess = data => ({
    type: Types.REHYDRATE_MOVEMENT_STATE_SUCCESS,
    data
});

export const getMovementListRequest = () => ({
    type: Types.GET_MOVEMENT_LIST_REQUEST
});

export const getMovementListSuccess = (data, meta) => ({
    type: Types.GET_MOVEMENT_LIST_SUCCESS,
    data,
    meta
});

export const getMovementListFailure = messages => ({
    type: Types.GET_MOVEMENT_LIST_FAILURE,
    messages
});

export const addNewMovementRequest = data => ({
    type: Types.ADD_NEW_MOVEMENT_REQUEST,
    data
});

export const addNewMovementSuccess = data => ({
    type: Types.ADD_NEW_MOVEMENT_SUCCESS,
    data
});

export const addNewMovementFailure = messages => ({
    type: Types.ADD_NEW_MOVEMENT_FAILURE,
    messages
});

export const deleteMovementRequest = id => ({
    type: Types.DELETE_MOVEMENT_REQUEST,
    id
});

export const deleteMovementSuccess = id => ({
    type: Types.DELETE_MOVEMENT_SUCCESS,
    id
});

export const deleteMovementFailure = messages => ({
    type: Types.DELETE_MOVEMENT_FAILURE,
    messages
});

export const putUpdateMovementRequest = (data, index) => ({
    type: Types.PUT_UPDATE_MOVEMENT_REQUEST,
    data,
    index
});

export const putUpdateMovementSuccess = (data, index) => ({
    type: Types.PUT_UPDATE_MOVEMENT_SUCCESS,
    data,
    index
});

export const putUpdateMovementFailure = messages => ({
    type: Types.PUT_UPDATE_MOVEMENT_FAILURE,
    messages
});

export const updateNewMovementRequest = data => {
    return {
        type: Types.UPDATE_NEW_MOVEMENT_REQUEST,
        data
    };
};

export const putUpdateNewMovementRequestSuccess = data => ({
    type: Types.UPDATE_NEW_MOVEMENT_SUCCESS,
    data
});

export const updateExistingMovementRequest = data => ({
    type: Types.UPDATE_EXISTING_MOVEMENT_REQUEST,
    data
});

export const putUpdateExistingMovementRequestSuccess = data => ({
    type: Types.UPDATE_EXISTING_MOVEMENT_SUCCESS,
    data
});

export const addNewTemplateRequest = data => ({
    type: Types.ADD_NEW_TEMPLATE_REQUEST,
    data
});

export const addNewTemplateSuccess = data => ({
    type: Types.ADD_NEW_TEMPLATE_SUCCESS,
    data
});

export const deleteTemplateRequest = id => ({
    type: Types.DELETE_TEMPLATE_REQUEST,
    id
});

export const deleteTemplateSuccess = id => ({
    type: Types.DELETE_TEMPLATE_SUCCESS,
    id
});

export const importTemplateRequest = id => ({
    type: Types.IMPORT_TEMPLATE_REQUEST,
    id
});

export const importTemplateSuccess = id => ({
    type: Types.IMPORT_TEMPLATE_SUCCESS,
    id
});

export const addExistingMovement = data => ({
    type:"ADD_EXISTING_MOVEMENT",
    data
})
